/**
 * @generated SignedSource<<f0127592e969ff3f7db7ab30e75db388>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteSection_section$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "DeleteSection_section";
};
export type DeleteSection_section$key = {
  readonly " $data"?: DeleteSection_section$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteSection_section">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteSection_section",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "SongSection",
  "abstractKey": null
};

(node as any).hash = "ddfa2b67909a977a059e6771d59e256d";

export default node;
